<template>
    <modal
        v-bind="{
            width,
            name,
            height,
            resizable,
            minWidth,
            minHeight,
            maxHeight
        }"
        @closed="onClose"
    >
        <div class="modal-holder">
            <i class="uil uil-multiply btn-close" @click="onClose" />
            <div class="holder">
                <slot name="default" />
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    name: 'AModal',
    props: {
        /**
         * The name for the modal.
         */
        name: {
            type: String,
            required: true,
        },
        /**
         * The width for the modal.
         */
        width: {
            type: Number,
            default: 600,
        },
        height: {
            type: Number | String,
            default: 'auto',
        },
        resizable: {
            type: Boolean,
            default: false,
        },
        minWidth: {
            type: Number,
            default: 0,
        },
        minHeight: {
            type: Number,
            default: 0,
        },
        maxHeight: {
            type: Number,
            default: 0,
        },
    },
    methods: {
        onClose() {
            /**
             * onClose event.
             *
             * @event click
             */
            this.$emit('onClose')
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'theme';
</style>

<style lang="scss">

</style>
